<template>
  <div
    class="home"
    id="yd-page1"
  >
    <div class="parent">
      <div class="login-shou">
        <div>
          <HeaderTop
            :subNavList="subNavList"
            @showYearBox="showYearBox"
            @sendCatalog="receiveCatalog"
          />
        </div>
      </div>
    </div>
    <div class="content">
      <!-- 首页精选的展示数据 广告位 -->
      <div
        v-show="selectedSubNav === 0"
        class="content_div"
      >
        <van-pull-refresh
          v-model="isLoading"
          @refresh="onRefresh"
        >
          <!-- 轮播 -->
          <Banner :bannerList="bannerList" />
          <!-- 金刚区域 -->
          <CustomButton :iconLists="iconLists" />
          <!-- 长图广告位 -->
          <Advertisement :advertisement="advertisement" />
          <!-- 活动 -->
          <HomeAdvert :advertLists="advertLists" />
          <!-- 直播公开课 -->
          <RecentLiveCourse
            ref="liveCours"
            :classCode='2'
            @openLive="openLive"
            @showRemindBox="showRemindBox"
            :examType=23
          />
          <!-- 热销课程榜单 -->
          <!-- 测试 :hotSaleId="113"-->
          <HotSaleCourse
            :hotSaleId="232"
            :pageName="23"
          />
          <!-- 考研咨询专区 -->
          <postgraduateChat :postgraduateChatList="postgraduateChatList" />

          <!-- 优惠券抢购专区 -->
          <HomeCoupon
            :examType="23"
            :couponadvertList="couponadvertList"
          />

          <!-- 精选课程 -->
          <HotCourse
            ref="hotCourse"
            :examSeason="23"
          />
          <HomePop
            v-if="isPopBox"
            @closePopBox="closePopBox"
            :popupData="popupData"
          />
        </van-pull-refresh>
      </div>
      <!-- 专业课课程列表，没有广告位 -->
      <div
        v-show="selectedSubNav !== 0"
        class="courseCard"
      >
        <CourseCard
          v-if="isCourseCard"
          :courseTabDetails="courseTabDetails"
        />
      </div>
      <Foot />
    </div>
    <GoToAppVue v-if="!$root.$data.isApp" />
    <!-- 开播提醒弹框 -->
    <RemindBox
      v-if="isRemindBox"
      @closeRemindBox="closeRemindBox"
    />
    <!-- 选择考季 -->
    <SelectType
      v-show="isYearTabBox"
      @closeYearBox="closeYearBox"
    />
    <!-- 直播弹出 -->
    <MultipleLiveCourse
      :videoList="videoList"
      :openCourseId="openCourseId"
      v-if="showLive"
      @closeLive="closeLive"
    />
    <!-- 悬浮聊天 -->
    <Chat :courseTabDetails="courseTabDetails" />

    <!-- 底部广告位 -->
    <transition name="fade">
      <Bottomadvert
        v-show="bottomadvertList && selectedSubNav === 0&&isShowAdvert"
        :examType=23
        :bottomadvertList="bottomadvertList"
        :bottomAreaHeight="bottomAreaHeight"
      />
    </transition>
  </div>
</template>

<script>
import loadJS from 'load-js';
import _ from 'lodash';
import { mapState } from 'vuex';
import { reqTypeList, reqAdvertPlaying } from '@/api/home';
import CourseCard from '@/pages/arkHome/courseCard.vue';
import Foot from '@/components/foot/privacy.vue';
import iconList from '@/utils/iconsTypes';
// import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import { gioJumpType, gioPlatform, homeGioAdShow } from '@/utils/tools';
import Bottomadvert from '@/components/bottomadvert/index.vue';
import HeaderTop from './components/appHeaderTop.vue';
import SelectType from './components/selectTypes.vue';
import Banner from './components/bannerVant.vue';
import CustomButton from './components/customButton.vue';
import HomeAdvert from './components/homeAdvert.vue';
import RecentLiveCourse from './components/recentLiveCourse.vue';
import HotCourse from './components/hotCourse.vue';
import RemindBox from '@/components/remindBox/index.vue';
import HomePop from './components/homePop.vue';
import GoToAppVue from '../../components/commonComponents/goToApp.vue';
import Advertisement from './components/advertisement.vue';
import Chat from './components/chat.vue';
import MultipleLiveCourse from '../../components/multipleLiveCourse/index.vue';
import postgraduateChat from './components/postgraduateChat.vue';
import HomeCoupon from '../../components/homeCoupon/index.vue';
import HotSaleCourse from './components/hotSaleCourse.vue';

export default {
  components: {
    HeaderTop,
    SelectType,
    Banner,
    CustomButton,
    HomeAdvert,
    RecentLiveCourse,
    HotCourse,
    RemindBox,
    CourseCard,
    HomePop,
    GoToAppVue,
    Advertisement,
    MultipleLiveCourse,
    Chat,
    postgraduateChat,
    Foot,
    Bottomadvert,
    HomeCoupon,
    HotSaleCourse,
  },

  data() {
    return {
      selectedSubNav: 0, // 当前选中的类目
      isYearTabBox: false, // 年份选择弹窗
      isRemindBox: false, // 开播提醒弹框
      navList: [], // 导航栏
      subNavList: [], // 二级类目列表
      bannerList: [], // 轮播图数据
      iconLists: [], // 金刚区
      advertLists: [], // 胶囊区
      advertisement: {}, // 长图广告未
      popupData: {}, // 弹窗
      isCourseCard: false,
      courseTabArr: [], // 23考研
      courseTabDetails: {}, // tab詳情
      isLoading: false, // 下拉刷新
      isPopBox: false,
      showPopBox: true, // 监听弹窗显示
      videoList: [],
      postgraduateChatList: [], // 考研咨询专区
      openCourseId: '',
      showLive: false,
      gioType: 1, // 1曝光 2关闭
      startX: 0, // 坐标
      startY: 0,
      isShowAdvert: true, // 是否展示广告位
      bottomadvertList: [], // 底部广告位
      couponadvertList: [], // 优惠券广告位
      bottomAreaHeight: 0,
    };
  },
  computed: {
    ...mapState(['currentYear']),
  },
  watch: {
    courseTabDetails: {
      handler(val) {
        this.isCourseCard = false;
        this.$nextTick(() => {
          this.isCourseCard = true;
          this.courseTabDetails = val;
        });
      },
    },
    deep: true,
  },

  beforeCreate() {
    loadJS([
      {
        async: false,
        url: 'https://p.bokecc.com/player?siteid=096E928BC2A97B87&newversion=true',
      },
      {
        async: false,
        url: '//player.polyv.net/script/player.js',
      },
      {
        async: false,
        url: '//pv.sohu.com/cityjson?ie=utf-8',
      },
    ]);
  },
  created() {
    setTimeout(() => {
      this.getTypeList();
    }, 500);
  },
  mounted() {
    this.$nextTick(() => {
      document.title = '启航教育';
      window['iqhApp2jsBridge.triggerSC'] = {};
      setTimeout(() => {
        // 获取登录状态
        window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
      }, 100);
      document.getElementsByClassName('app')[0].setAttribute('style', 'height: 100%');
      sessionStorage.removeItem('fromPageUrl'); // 清除referer记录，提交订单接口用referer
      this.appHideChat();
      // 监听滑动事件
      this.bindEvent();
      this.bottomAreaHeight = document.getElementsByClassName('bottomArea')[0].clientHeight;
    });
  },

  methods: {
    // 下拉刷新
    onRefresh() {
      this.isLoading = false;
      sessionStorage.removeItem('HomePopup');
      setTimeout(() => {
        this.getTypeList();
      }, 500);
      this.$refs.hotCourse.skeleton = true;
      this.$refs.hotCourse.getRecommend();
      this.$refs.liveCours.getOpenCourse();
      // 下拉刷新调用app的首页弹窗
      // if (this.$root.$data.isApp) {
      //   this.$sendToApp('showAdvertPopupWindow');
      // }
    },
    receiveCatalog(data) {
      this.selectedSubNav = data.index;
      if (data.index === 0) {
        setTimeout(() => {
          this.getTypeList();
        }, 500);
      } else {
        this.courseTabDetails = this.courseTabArr[data.index - 1];
      }
    },

    // 获取分类列表
    async getTypeList() {
      const res = await reqTypeList('HOME_EXAM_CONFIG_H5');
      if (res.code === 0) {
        this.navList = res.data;
        res.data.forEach((item) => {
          if (item.code === '2') {
            this.courseTabArr = JSON.parse(item.remark);
          }
        });
        // if (this.$root.$data.isApp) {
        //   this.$sendToApp('showAdvertPopupWindow', 2);
        // }
        this.getSubNavList(this.navList);
        this.navList.map((item) => {
          // eslint-disable-next-line array-callback-return
          iconList.map((e) => {
            if (item.code === e.code) {
              Object.assign(item, e);
              // return item;
            }
          });
          return item;
        });
        this.newData = this.navList;
      }
    },
    // 请求23考季的专业分类（数学 英语 政治 管综 专业课）
    getSubNavList(navList) {
      const res = navList.find((item) => item.code === '2');
      if (res) {
        this.subNavList = JSON.parse(res.remark);
        this.subNavList.unshift({ id: 0, name: '精选' });

        this.getBanner();
      }
    },
    // 请求广告位
    async getBanner() {
      const paramsList = ['App00001', 'App00002', 'App00003', 'App00004', 'App00010', 'zx001', 'App100', 'App102'];
      const res = await reqAdvertPlaying(paramsList);
      if (res.code === 0) {
        // 首页banner
        this.bannerList = res.data?.find(
          (item) => item.adCode === paramsList[0],
        )?.advertisingContentWebInfoRespVOS;
        // 请求金刚区
        this.iconLists = res.data?.find(
          (item) => item.adCode === paramsList[1],
        )?.advertisingContentWebInfoRespVOS;
        // 请求胶囊区
        this.advertLists = res.data?.find(
          (item) => item.adCode === paramsList[2],
        )?.advertisingContentWebInfoRespVOS;
        // 首页弹窗
        this.popupData = res.data?.find(
          (item) => item.adCode === paramsList[3],
        )?.advertisingContentWebInfoRespVOS[0];
        if (this.popupData) {
          if (!this.$root.$data.isApp) {
            this.isPopBox = true;
            this.gioEvent((this.gioType = 1));
          }

          if (sessionStorage.getItem('HomePopup')) {
            this.isPopBox = false;
          }
        }
        // 首页长图广告位
        this.advertisement = res.data?.find(
          (item) => item.adCode === paramsList[4],
        )?.advertisingContentWebInfoRespVOS[0];
        // 首页考研咨询广告位
        this.postgraduateChatList = res.data?.find(
          (item) => item.adCode === paramsList[5],
        )?.advertisingContentWebInfoRespVOS;
        // 首页底部广告位
        this.bottomadvertList = res.data?.find(
          (item) => item.adCode === paramsList[6],
        )?.advertisingContentWebInfoRespVOS;

        if (this.bottomadvertList?.length && !this.$root.$data.isApp) {
          this.bottomadvertList[0].adPosition_var = '23考研-首页-底部广告';
          homeGioAdShow(this.bottomadvertList);
        }
        // 首页优惠券广告位
        this.couponadvertList = res.data?.find(
          (item) => item.adCode === paramsList[7],
        )?.advertisingContentWebInfoRespVOS;
        if (this.couponadvertList?.length && !this.$root.$data.isApp) {
          this.couponadvertList[0].adPosition_var = '23考研-首页-优惠券广告';
          homeGioAdShow(this.couponadvertList);
        }
      }
    },
    // 选择考季更改二级目录
    changeSubNavList(data) {
      this.subNavList = JSON.parse(data);
    },
    // 显示选择年份弹框
    showYearBox() {
      this.isYearTabBox = true;
      this.noScroll();
      if (this.$root.$data.isApp) {
        this.$sendToApp('hideBottomSidebar');
      }
    },
    // 关闭选择年份弹框
    closeYearBox() {
      this.isYearTabBox = false;
      this.canScroll();
      // App显示底部导航
      if (this.$root.$data.isApp) {
        this.$sendToApp('showBottomSidebar');
      }
    },
    showRemindBox() {
      // 打开开播提醒
      this.isRemindBox = true;
    },
    closeRemindBox() {
      // 关闭开播提醒
      this.isRemindBox = false;
    },
    closePopBox() {
      this.isPopBox = false;
      // 存session 控制弹窗
      sessionStorage.setItem('HomePopup', true);
      this.gioEvent((this.gioType = 2));
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
      setTimeout(() => {
        this.getTypeList();
      }, 500);
      await this.$refs.hotCourse.getRecommend();
      await this.$refs.liveCours.getOpenCourse();
    },
    getLogin(APPSESSION) {
      const cookieToken = APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    closeLive() {
      this.showLive = false;
    },
    openLive(data) {
      this.videoList = data.videoList;
      this.openCourseId = data.openCourseRecordId;
      this.showLive = true;
    },
    appHideChat() {
      // if (!this.$root.$data.isApp) return;
      // const node = document.getElementById('zc__invite__container');
      // const node1 = document.getElementById('zc__sdk__container');
      // if (node) {
      //   node.parentNode.removeChild(node);
      // }
      // if (node1) {
      //   node1.parentNode.removeChild(node1);
      // }
      // // eslint-disable-next-line no-undef
      // zc('config', {
      //   manual: true, // 设置成手动初始化
      //   custom: false, // 设置自定义按钮生效 第二步
      //   auto_expand: false,
      //   channelid: 5, // 非自动弹框
      //   invite_flag: false,
      //   expand_size: 'half',
      //   invite: 0,
      // });
    },
    gioEvent(type) {
      const { title, skipType } = this.popupData;
      const adId = this.popupData.id;
      if (type === 2) {
        // 关闭广告埋点
        // eslint-disable-next-line
        gio('track', 'adClose_event', {
          adPosition_var: '23考研-首页-弹窗', // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adId.toString(), // 广告ID
          adName_var: title, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType), // 跳转类型
          platform_var: gioPlatform(),
        });
      } else {
        // 广告曝光
        // eslint-disable-next-line
        gio('track', 'adShown_event', {
          adPosition_var: '23考研-首页-弹窗', // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adId.toString(), // 广告ID
          adName_var: title, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType), // 跳转类型
          platform_var: gioPlatform(),
        });
      }
    },
    checkRoute() {
      const { code } = this.currentYear;
      const { path } = this.$route;
      if (!(Number(code) === 2 && path === '/home')) {
        this.$refs.HeaderTop.jumpPage(code);
      }
    },

    // 滑动
    touchStart(evt) {
      try {
        const touch = evt.touches[0]; // 获取第一个触点
        const x = Number(touch.pageX); // 页面触点X坐标
        const y = Number(touch.pageY); // 页面触点Y坐标
        // 记录触点初始位置
        this.startX = x;
        this.startY = y;
      } catch (e) {
      }
    },

    touchMove(evt) {
      try {
        const touch = evt.touches[0]; // 获取第一个触点
        // x = Number(touch.pageX), //页面触点X坐标
        const y = Number(touch.pageY); // 页面触点Y坐标
        // 判断滑动方向
        if (y - this.startY < 0) {
          // console.log('上滑了！');
          this.isShowAdvert = false;
        } else {
          // console.log('下滑了！');
          this.isShowAdvert = true;
        }
      } catch (e) {
      }
    },

    // 绑定事件
    bindEvent() {
      document.addEventListener('touchstart', _.debounce(this.touchStart, 300, true), false);
      document.addEventListener('touchmove',
        _.debounce(this.touchMove, 300, true), false);
    },
  },

  beforeDestroy() {
    clearTimeout();
    document.getElementsByClassName('app')[0].removeAttribute('style');
  },
};
</script>

<style lang="scss" scoped>
.common-foot {
  // bottom: 110px;
  position: relative;
  margin-top: 40px;
}
.home {
  position: absolute;
  width: 100%;
  // min-height: 1000;
  // padding: 0 40px;
  padding-bottom: 200px;
  background: #fefeff;
}
.parent {
  width: 100%;
  padding: 0 36px;
}

.content {
  height: 100%;
  padding-top: 182px;
  &_div {
    min-height: 100vh;
  }
}
::v-deep .van-pull-refresh {
  height: 100%;
  overflow: inherit;
}

.courseCard {
  padding: 0 40px;
}

// 动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
